import BaseService from '../../../BaseService.js'

export default class ChartService extends BaseService {

  constructor() {
    super('chart')
  }

  async getTemperatur(bilanzzone, startDate, endDate) {
    await this.retrieveBackendUrl();
    return this.checkError(
      fetch(`${this.backendUrl}/temperatur/${bilanzzone}?from=${startDate}&to=${endDate}`, {
        method: 'GET',
        cache: 'reload',
        headers: this.getJsonHeader()
      })
    );
  }

  async getVerbrauch(bilanzzone, startDate, endDate) {
    await this.retrieveBackendUrl();
    return this.checkError(
      fetch(`${this.backendUrl}/verbrauch/${bilanzzone}?from=${startDate}&to=${endDate}`, {
        method: 'GET',
        cache: 'reload',
        headers: this.getJsonHeader()
      })
    );
  }

  async getVerbrauchPrognose(bilanzzone, startDate, endDate) {
    await this.retrieveBackendUrl();
    return this.checkError(
      fetch(`${this.backendUrl}/verbrauch/prognose/${bilanzzone}?from=${startDate}&to=${endDate}`, {
        method: 'GET',
        cache: 'reload',
        headers: this.getJsonHeader()
      })
    );
  }

  async getVerbrauchMlPrognose(bilanzzone, startDate, endDate) {
    await this.retrieveBackendUrl();
    return this.checkError(
      fetch(`${this.backendUrl}/verbrauch/ml-prognose/${bilanzzone}?from=${startDate}&to=${endDate}`, {
        method: 'GET',
        cache: 'reload',
        headers: this.getJsonHeader()
      })
    );
  }

  async getGebuchteKapazitaet(bilanzzone, startDate, endDate) {
    await this.retrieveBackendUrl();
    return this.checkError(
      fetch(`${this.backendUrl}/kapazitaet/gebucht/${bilanzzone}?from=${startDate}&to=${endDate}`, {
        method: 'GET',
        cache: 'reload',
        headers: this.getJsonHeader()
      })
    );
  }

  async getAngebot(bilanzzone, startDate, endDate) {
    await this.retrieveBackendUrl();
    return this.checkError(
      fetch(`${this.backendUrl}/angebot/${bilanzzone}?from=${startDate}&to=${endDate}`, {
        method: 'GET',
        cache: 'reload',
        headers: this.getJsonHeader()
      })
    );
  }

  async getRegAngebot(bilanzzone, startDate, endDate) {
    await this.retrieveBackendUrl();
    return this.checkError(
      fetch(`${this.backendUrl}/reg-angebot/${bilanzzone}?from=${startDate}&to=${endDate}`, {
        method: 'GET',
        cache: 'reload',
        headers: this.getJsonHeader()
      })
    );
  }

  async getNominierteKapazitaet(bilanzzone, startDate, endDate) {
    await this.retrieveBackendUrl();
    return this.checkError(
      fetch(`${this.backendUrl}/kapazitaet/nominiert/${bilanzzone}?from=${startDate}&to=${endDate}`, {
        method: 'GET',
        cache: 'reload',
        headers: this.getJsonHeader()
      })
    );
  }

  async getVerbrauchPrognoseMitMassnahmen(massnahmen, bilanzzone, startDate, endDate) {
    await this.retrieveBackendUrl();
    return this.checkError(
      fetch(`${this.backendUrl}/verbrauch/prognose/massnahmen/${bilanzzone}?from=${startDate}&to=${endDate}`, {
        method: 'PUT',
        cache: 'reload',
        headers: this.getJsonHeader(),
        body: JSON.stringify(massnahmen)
      })
    );
  }

  async calcKontingentierungsfaktor(massnahmen, bilanzzone, startDate) {
    await this.retrieveBackendUrl();
    return this.checkError(
      fetch(`${this.backendUrl}/kontingentierung/faktor/${bilanzzone}?from=${startDate}`, {
        method: 'PUT',
        cache: 'reload',
        headers: this.getJsonHeader(),
        body: JSON.stringify(massnahmen)
      })
    );
  }
}
